import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
const beats = ['Todos duermen tranquilos porque tú resolviste todo, otra vez.', 'Podrías caer rendida… pero hoy eliges otra cosa.', 'Te preparas un té. Abres el eBook. Lees una frase que te abraza.', 'Respiras. Te pones tu crema favorita. Y, por primera vez en años, te sientes tú.'];
export function ImagineSection() {
  return <section className="w-full bg-plum py-20 text-cream sm:py-28" aria-labelledby="imagine-title" data-id="element-98" data-mp="nr2l9h245nox">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-99" data-mp="srqapyap1wh1">
        <div className="flex flex-col items-center text-center" data-id="element-100" data-mp="dtxvz8cz1c3w">
          <MoonIcon className="h-7 w-7 text-blush" aria-hidden="true" data-id="element-101" data-mp="dvsjmufmnibo" />
          <h2 id="imagine-title" className="mt-5 font-display text-3xl leading-tight sm:text-5xl" data-id="element-102" data-mp="itk9zk0miwdr">
            Imagina esto…
          </h2>
        </div>

        <ol className="mt-12 space-y-6" data-id="element-103" data-mp="2d5qwvg2vr1lw">
          {beats.map((beat, index) => <motion.li key={beat} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-5 border-b border-cream/10 pb-6 last:border-0" data-id="element-104" data-mp="hva7wew20q6a" data-mpi={index}>
              <span className="font-display text-2xl text-blush/70" aria-hidden="true" data-id="element-105" data-mp="mp4nb64mmizk">
                0{index + 1}
              </span>
              <p className="text-lg leading-relaxed text-cream/85 sm:text-xl" data-id="element-106" data-mp="3q4afj7245rq3">{beat}</p>
            </motion.li>)}
        </ol>

        <p className="mt-10 text-center font-display text-2xl italic leading-snug text-blush sm:text-3xl" data-id="element-107" data-mp="7zfj1218lyv2">
          Aunque sea por cinco minutos. Pero cinco minutos que lo cambian todo.
        </p>
      </div>
    </section>;
}